import { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Foodie from './pages/Foodie';
import Venues from './pages/Venues';
import Profile from './pages/Profile';
import RestaurantDetail from './pages/RestaurantDetail';
import Recommendations from './pages/Recommendations';
import RecommendationEngagement from './pages/RecommendationEngagement';
import AuthCallback from './pages/AuthCallback';
import BusinessPortal from './pages/Business';
import PublicProfile from './pages/PublicProfile';
import MyFoodListPage from './pages/MyFoodListPage';
import CreateFoodCardPage from './pages/CreateFoodCardPage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import LeaderboardPage from './pages/LeaderboardPage';
import FoodMapPage from './pages/FoodMapPage';
import DMPage from './pages/DMPage';
import CommunitiesPage from './pages/CommunitiesPage';
import ChallengesPage from './pages/ChallengesPage';
import SpacesPage from './pages/SpacesPage';
import FollowPage from './pages/FollowPage';
import DiscoverPage from './pages/DiscoverPage';
import SurpriseMePage from './pages/SurpriseMePage';
import AIChatPage from './pages/AIChatPage';
import ModerationDashboard from './pages/ModerationDashboard';
import Deals from './pages/Deals';
import Events from './pages/Events';
import { Toaster } from './components/ui/toaster';
import AIChatbot from './components/AIChatbot';
import InstallPrompt from './components/InstallPrompt';
import { AuthProvider } from './contexts/AuthContext';
import { FoodlistProvider } from './contexts/FoodlistContext';
import { LocationProvider } from './contexts/LocationContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { I18nProvider } from './contexts/I18nContext';
import MobileBottomNav from './components/MobileBottomNav';
import { usePrefetch } from './hooks/usePrefetch';

// Register service worker for PWA + push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('SW registration failed:', err);
    });
  });
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  const [savedItems, setSavedItems] = useState([1, 3, 4]);

  // Prefetch all page data in background on app mount
  usePrefetch();

  const toggleSave = (id) => {
    setSavedItems(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  // Detect OAuth callback synchronously before any rendering
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home savedItems={savedItems} toggleSave={toggleSave} />} />
        <Route path="/foodie" element={<Foodie />} />
        <Route path="/venues" element={<Venues />} />
        <Route path="/deals" element={<Deals />} />
        <Route path="/events" element={<Events />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:userId" element={<PublicProfile />} />
        <Route path="/restaurant/:id" element={<RestaurantDetail savedItems={savedItems} toggleSave={toggleSave} />} />
        <Route path="/recommendations" element={<Recommendations />} />
        <Route path="/recommendations/engagement" element={<RecommendationEngagement />} />
        <Route path="/ai-search" element={<SurpriseMePage />} />
        <Route path="/myfoodlist" element={<MyFoodListPage />} />
        <Route path="/create-foodcard" element={<CreateFoodCardPage />} />
        <Route path="/recipes" element={<RecipeDetailPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/map" element={<FoodMapPage />} />
        <Route path="/messages" element={<DMPage />} />
        <Route path="/communities" element={<CommunitiesPage />} />
        <Route path="/challenges" element={<ChallengesPage />} />
        <Route path="/spaces" element={<SpacesPage />} />
        <Route path="/following" element={<FollowPage />} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/surprise-me" element={<SurpriseMePage />} />
        <Route path="/ai-chat" element={<AIChatPage />} />
        <Route path="/admin/moderation" element={<ModerationDashboard />} />
        <Route path="/business" element={<BusinessPortal />} />
        <Route path="/business/register" element={<BusinessPortal />} />
        {/* Legacy redirects */}
        <Route path="/venue" element={<Venues />} />
        <Route path="/search" element={<SurpriseMePage />} />
        <Route path="/collections" element={<SurpriseMePage />} />
        <Route path="/food-chat" element={<AIChatPage />} />
      </Routes>
      <InstallPrompt />
      <MobileBottomNav />
      <Toaster />
      <AIChatbot />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
        <I18nProvider>
        <AuthProvider>
          <LocationProvider>
            <WebSocketProvider>
              <FoodlistProvider>
                <AppRouter />
              </FoodlistProvider>
            </WebSocketProvider>
          </LocationProvider>
        </AuthProvider>
        </I18nProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
